import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',

    paddingHorizontal: 53,
    paddingVertical: 40,
    paddingBottom: 20,
    backgroundColor: '#F5F5F5',
  },

  fullWidthContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },

  pageTitle: {
    fontSize: 40,
    fontWeight: 700,
    fontFamily: 'Lato',
    lineHeight: 1.4,
    textTransform: 'uppercase',
    color: 'black',
  },

  galleryContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    rowGap: 18,
    columnGap: 23.5,
    width: '100%',
  },
  button: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 8,
    fontSize: 14,
    textDecoration: 'none',
    textAlign: 'center',
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    padding: 10,
    width: 146,
    height: 74,
  },
  logoImage: {
    width: 130,
    objectFit: 'contain',
  },
});
